import React, { useState } from 'react';
const PercentageChangeCalculator = () => {
  const [value1, setValue1] = useState('');
  const [option, setOption] = useState('increase');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Please enter both values correctly');
      setResult('');
      setExplanation('');
      return;
    }
    const val1 = parseFloat(value1);
    const percent = parseFloat(value2);
    let calculatedValue = 0;
    let calculationSteps = `${val1} ${option === 'increase' ? 'increased' : 'decreased'} by ${value2}% = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${value2}%) = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${percent}%) = `;
    if (option === 'increase') {
      calculatedValue = val1 + (val1 * percent) / 100;
    } else if (option === 'decrease') {
      calculatedValue = val1 - (val1 * percent) / 100;
    }
    setResult(calculatedValue.toFixed(2));
    setExplanation(calculationSteps + calculatedValue.toFixed(2))
    setError('');
  };
  const handleOptionChange = (e) => {
    setOption(e.target.value);
  };
  return (
    <div dir="ltr">
     <u><h2 style={{ fontSize: '16px' }}>Percentage Change Calculator</h2>  </u><br/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <label htmlFor="value1">Value:</label>
      <input
          type="number"
          placeholder="Value"
          value={value1}
          id='value1'
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px' ,marginLeft: '5px' }}
        />
        <label htmlFor="option">Change:</label>
        <select id='option' style={{ width: '90%' }} className="form-select" value={option} onChange={handleOptionChange}>
          <option value="increase">Increase</option>
          <option value="decrease">Decrease</option>
        </select>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          placeholder="Percentage"
          value={value2}
          id='value2'
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px', marginLeft: '5px', marginRight: '5px' }}
        />
        <span>%</span>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px' }}
          onClick={handleCalculate}
        >
          Calculate
        </button>
      </div>
      <br />
      <div>
      {error !== '' ? (
        <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
      ) : (
        <>
          {result !== '' && (
            <>
              <p className='p-3 mb-2 bg-success text-white'>
                Result: {value1} {option === 'increase' ? 'increased' : option === 'decrease' ? 'decreased' : option} by {value2}% = {result}
              </p>
              {explanation !== '' && (
                <p className='p-3 mb-2 bg-info text-black'>
                  Solution Steps: <br/>{explanation}
                </p>
              )}
            </>
          )}
        </>
      )}
    </div>
    </div>
  );
};
export default PercentageChangeCalculator;
